import { environment } from '@pgaoc/shared-lib';

class InternalUserAuth {
  static login(): string {
    return `${environment.mainServiceUrl}internalportal/internalusers/login`;
  }
  static refreshSession(email: string): string {
    return `${environment.mainServiceUrl}internalportal/internalusers/${email}/refreshsession`;
  }
  static resetPassword(email: string): string {
    return `${environment.mainServiceUrl}internalportal/internalusers/${email}/forgotpassword`;
  }
  static setNewPassword(email: string): string {
    return `${environment.mainServiceUrl}internalportal/internalusers/${email}/resetforgottenpassword`;
  }
}

class MemberAuth {
  static resetPassword(memberId: number): string {
    return `${environment.mainServiceUrl}memberportal/members/${memberId}/forgotpassword`;
  }
}

class InternalUsers {
  static getRoles(): string {
    return `${environment.mainServiceUrl}odata/internalportal/internaluserroles`;
  }

  static createUser(): string {
    return `${environment.mainServiceUrl}internalportal/internalusers`;
  }

  static getUsers(): string {
    return `${environment.mainServiceUrl}odata/internalportal/internalusers`;
  }
}

class Facilities {
  static updateFacility(facilityId: number): string {
    return `${environment.mainServiceUrl}internalportal/facilities/${facilityId}`;
  }

  static deleteFacility(facilityId: number): string {
    return `${environment.mainServiceUrl}internalportal/facilities/${facilityId}`;
  }

  static updateFacilityContact(facilityId: number, facilityContactId: number): string {
    return `${environment.mainServiceUrl}internalportal/facilities/${facilityId}/contacts/${facilityContactId}`;
  }

  static deleteFacilityContact(facilityId: number, facilityContactId: number): string {
    return `${environment.mainServiceUrl}internalportal/facilities/${facilityId}/contacts/${facilityContactId}`;
  }
}

class Members {
  static getMembers(): string {
    return `${environment.mainServiceUrl}odata/internalportal/members`;
  }
  static getMemberSummaries(): string {
    return `${environment.mainServiceUrl}odata/internalportal/membersummaries`;
  }
  static getMember(memberId: number): string {
    return `${environment.mainServiceUrl}odata/internalportal/members/${memberId}`;
  }
  static createMember(): string {
    return `${environment.mainServiceUrl}internalportal/members`;
  }
  static updateMember(memberId: number): string {
    return `${environment.mainServiceUrl}internalportal/members/${memberId}`;
  }
  static getMemberSpecializations(): string {
    return `${environment.mainServiceUrl}odata/internalportal/memberspecializations`;
  }
  static updateMemberSpecializations(memberSpecializationId: number): string {
    return `${environment.mainServiceUrl}internalportal/memberspecializations/${memberSpecializationId}`;
  }
  static createMemberSpecializations(): string {
    return `${environment.mainServiceUrl}internalportal/memberspecializations`;
  }
}

class MembershipApplications {
  static getMembershipApplications(): string {
    return `${environment.mainServiceUrl}odata/internalportal/membershipapplications`;
  }
  static getMembershipApplicationSummaries(): string {
    return `${environment.mainServiceUrl}odata/internalportal/membershipapplicationsummaries`;
  }
  static updateMembershipApplication(applicationId: number): string {
    return `${environment.mainServiceUrl}internalportal/membershipapplications/${applicationId}`;
  }
  static getApplicationTaskTypes(): string {
    return `${environment.mainServiceUrl}odata/internalportal/applicationtasks`;
  }
}

class MembershipReinstatements {
  static getMembershipReinstatements(): string {
    return `${environment.mainServiceUrl}odata/internalportal/membershipreinstatementapplications`;
  }
  static getMembershipReinstatementSummaries(): string {
    return `${environment.mainServiceUrl}odata/internalportal/membershipreinstatementapplicationsummaries`;
  }
  static updateMembershipReinstatementApplication(reinstatementId: number): string {
    return `${environment.mainServiceUrl}internalportal/membershipreinstatementapplications/${reinstatementId}`;
  }
}

class MembershipReapplicationApplications {
  static getMembershipReapplications(): string {
    return `${environment.mainServiceUrl}odata/internalportal/membershipreapplicationapplications`;
  }
  static getMembershipReapplicationSummaries(): string {
    return `${environment.mainServiceUrl}odata/internalportal/membershipreapplicationapplicationsummaries`;
  }
  static updateMembershipReapplicationApplication(reapplicationId: number): string {
    return `${environment.mainServiceUrl}internalportal/membershipreapplicationapplications/${reapplicationId}`;
  }
}

class Championships {
  static createChampionship(): string {
    return `${environment.mainServiceUrl}internalportal/championships`;
  }
  static getChampionshipById(championshipId: number): string {
    return `${environment.mainServiceUrl}odata/internalportal/championships/${championshipId}`;
  }
  static getChampionshipSummaries(): string {
    return `${environment.mainServiceUrl}odata/internalportal/championshipsummaries`;
  }
  static updateChampionship(championshipId: number): string {
    return `${environment.mainServiceUrl}internalportal/championships/${championshipId}`;
  }
  static deleteChampionship(championshipId: number): string {
    return `${environment.mainServiceUrl}internalportal/championships/${championshipId}`;
  }

  static createHostHotel(championshipId: number): string {
    return `${environment.mainServiceUrl}internalportal/championships/${championshipId}/hosthotels`;
  }
  static getHostHotels(championshipId: number): string {
    return `${environment.mainServiceUrl}odata/internalportal/championships/${championshipId}/hosthotels`;
  }
  static updateHostHotel(championshipId: number, hosthotelId: number): string {
    return `${environment.mainServiceUrl}internalportal/championships/${championshipId}/hosthotels/${hosthotelId}`;
  }
  static deleteHostHotel(championshipId: number, hosthotelId: number): string {
    return `${environment.mainServiceUrl}internalportal/championships/${championshipId}/hosthotels/${hosthotelId}`;
  }

  static createSponsorLogo(championshipId: number): string {
    return `${environment.mainServiceUrl}internalportal/championships/${championshipId}/sponsorlogos`;
  }
  static updateSponsorLogoUrl(championshipId: number, sponsorLogoId: number): string {
    return `${environment.mainServiceUrl}internalportal/championships/${championshipId}/sponsorlogos/${sponsorLogoId}/updateurl`;
  }
  static getSponsorLogos(championshipId: number): string {
    return `${environment.mainServiceUrl}odata/internalportal/championships/${championshipId}/sponsorlogos`;
  }
  static deleteSponsorLogo(championshipId: number, sponsorLogoId: number): string {
    return `${environment.mainServiceUrl}internalportal/championships/${championshipId}/sponsorlogos/${sponsorLogoId}`;
  }

  static createChampionshipRegistration(championshipId: number): string {
    return `${environment.mainServiceUrl}internalportal/championships/${championshipId}/registrations`;
  }
  static createChampionshipRegistrationEligibilities(registrationId: number): string {
    return `${environment.mainServiceUrl}internalportal/championshipregistrations/${registrationId}/eligibilities`;
  }
  static getChampionshipRegistrations(championshipId: number): string {
    return `${environment.mainServiceUrl}odata/internalportal/championships/${championshipId}/registrations`;
  }
  static updateChampionshipRegistration(championshipId: number, registrationId: number): string {
    return `${environment.mainServiceUrl}internalportal/championships/${championshipId}/registrations/${registrationId}`;
  }
  static deleteChampionshipRegistration(championshipId: number, registrationId: number): string {
    return `${environment.mainServiceUrl}internalportal/championships/${championshipId}/registrations/${registrationId}`;
  }

  static createFormField(registrationId: number): string {
    return `${environment.mainServiceUrl}internalportal/championshipregistrations/${registrationId}/formfields`;
  }
  static updateFormField(registrationId: number, formFieldId: number): string {
    return `${environment.mainServiceUrl}internalportal/championshipregistrations/${registrationId}/formfields/${formFieldId}`;
  }
  static deleteFormField(registrationId: number, formFieldId: number): string {
    return `${environment.mainServiceUrl}internalportal/championshipregistrations/${registrationId}/formfields/${formFieldId}`;
  }

  static getParticipantSummaries(championshipId: number): string {
    return `${environment.mainServiceUrl}odata/internalportal/championships/${championshipId}/participantsummaries`;
  }
  static updateParticipantStatus(championshipId: number, participantId: number): string {
    return `${environment.mainServiceUrl}internalportal/championships/${championshipId}/participants/${participantId}`;
  }
  static getChampionshipParticipantById(championshipId: number, participantId: number): string {
    return `${environment.mainServiceUrl}odata/internalportal/championships/${championshipId}/participants/${participantId}`;
  }
}

class Events {
  static createEvent(): string {
    return `${environment.mainServiceUrl}internalportal/events`;
  }
  static getEventById(eventId: number): string {
    return `${environment.mainServiceUrl}odata/internalportal/events/${eventId}`;
  }
  static getEventSummaries(): string {
    return `${environment.mainServiceUrl}odata/internalportal/eventsummaries`;
  }
  static updateEvent(eventId: number): string {
    return `${environment.mainServiceUrl}internalportal/events/${eventId}`;
  }
  static deleteEvent(eventId: number): string {
    return `${environment.mainServiceUrl}internalportal/events/${eventId}`;
  }

  static createHostHotel(eventId: number): string {
    return `${environment.mainServiceUrl}internalportal/events/${eventId}/hosthotels`;
  }
  static getHostHotels(eventId: number): string {
    return `${environment.mainServiceUrl}odata/internalportal/events/${eventId}/hosthotels`;
  }
  static updateHostHotel(eventId: number, hosthotelId: number): string {
    return `${environment.mainServiceUrl}internalportal/events/${eventId}/hosthotels/${hosthotelId}`;
  }
  static deleteHostHotel(eventId: number, hosthotelId: number): string {
    return `${environment.mainServiceUrl}internalportal/events/${eventId}/hosthotels/${hosthotelId}`;
  }

  static createSponsorLogo(eventId: number): string {
    return `${environment.mainServiceUrl}internalportal/events/${eventId}/sponsorlogos`;
  }
  static updateSponsorLogoUrl(eventId: number, sponsorLogoId: number): string {
    return `${environment.mainServiceUrl}internalportal/events/${eventId}/sponsorlogos/${sponsorLogoId}/updateurl`;
  }
  static getSponsorLogos(eventId: number): string {
    return `${environment.mainServiceUrl}odata/internalportal/events/${eventId}/sponsorlogos`;
  }
  static deleteSponsorLogo(eventId: number, sponsorLogoId: number): string {
    return `${environment.mainServiceUrl}internalportal/events/${eventId}/sponsorlogos/${sponsorLogoId}`;
  }

  static createVendorLogo(eventId: number): string {
    return `${environment.mainServiceUrl}internalportal/events/${eventId}/vendorlogos`;
  }
  static updateVendorLogoUrl(eventId: number, vendorLogoId: number): string {
    return `${environment.mainServiceUrl}internalportal/events/${eventId}/vendorlogos/${vendorLogoId}/updatevendorurl`;
  }
  static getVendorLogos(eventId: number): string {
    return `${environment.mainServiceUrl}odata/internalportal/events/${eventId}/vendorlogos`;
  }
  static deleteVendorLogo(eventId: number, vendorLogoId: number): string {
    return `${environment.mainServiceUrl}internalportal/events/${eventId}/vendorlogos/${vendorLogoId}`;
  }

  static createEventRegistration(eventId: number): string {
    return `${environment.mainServiceUrl}internalportal/events/${eventId}/registrations`;
  }
  static createEventRegistrationEligibilities(registrationId: number): string {
    return `${environment.mainServiceUrl}internalportal/eventregistrations/${registrationId}/eligibilities`;
  }
  static getEventRegistrations(eventId: number): string {
    return `${environment.mainServiceUrl}odata/internalportal/events/${eventId}/registrations`;
  }
  static updateEventRegistration(eventId: number, registrationId: number): string {
    return `${environment.mainServiceUrl}internalportal/events/${eventId}/registrations/${registrationId}`;
  }
  static deleteEventRegistration(eventId: number, registrationId: number): string {
    return `${environment.mainServiceUrl}internalportal/events/${eventId}/registrations/${registrationId}`;
  }

  static createFormField(registrationId: number): string {
    return `${environment.mainServiceUrl}internalportal/eventregistrations/${registrationId}/formfields`;
  }
  static updateFormField(registrationId: number, formFieldId: number): string {
    return `${environment.mainServiceUrl}internalportal/eventregistrations/${registrationId}/formfields/${formFieldId}`;
  }
  static deleteFormField(registrationId: number, formFieldId: number): string {
    return `${environment.mainServiceUrl}internalportal/eventregistrations/${registrationId}/formfields/${formFieldId}`;
  }

  static getParticipantSummaries(eventId: number): string {
    return `${environment.mainServiceUrl}odata/internalportal/events/${eventId}/participantsummaries`;
  }
  static updateParticipantStatus(eventId: number, participantId: number): string {
    return `${environment.mainServiceUrl}internalportal/events/${eventId}/participants/${participantId}`;
  }
  static getEventParticipantById(eventId: number, participantId: number): string {
    return `${environment.mainServiceUrl}odata/internalportal/events/${eventId}/participants/${participantId}`;
  }
}

class Taxes {
  private static readonly url = `${environment.mainServiceUrl}internalportal/taxes`;
  private static readonly odataUrl = `${environment.mainServiceUrl}odata/internalportal/taxes`;

  static createTax(): string {
    return this.url;
  }

  static getTaxes(): string {
    return this.odataUrl;
  }

  static getTax(taxId: number): string {
    return `${this.url}/${taxId}`;
  }

  static createTaxRate(taxId: number): string {
    return `${this.url}/${taxId}/rates`;
  }

  static updateTaxRate(taxId: number, taxRateId: number): string {
    return `${this.url}/${taxId}/rates/${taxRateId}`;
  }

  static getTaxRates(taxId: number): string {
    return `${this.odataUrl}/${taxId}/rates`;
  }

  static getTaxRate(taxId: number, taxRateId: number): string {
    return `${this.url}/${taxId}/rates/${taxRateId}`;
  }
}

class GlAccounts {
  private static readonly url = `${environment.mainServiceUrl}internalportal/glaccounts`;
  private static readonly odataUrl = `${environment.mainServiceUrl}odata/internalportal/glaccounts`;

  static createGlAccount(): string {
    return this.url;
  }

  static updateGlAccount(id: number): string {
    return `${this.url}/${id}`;
  }

  static getGlAccounts(): string {
    return this.odataUrl;
  }
}

class Invoices {
  private static readonly url = `${environment.mainServiceUrl}internalportal/invoices`;
  private static getLineItemUrl(id: number) {
    return `${environment.mainServiceUrl}internalportal/invoices/${id}/lineitems`;
  }
  private static getTaxUrl(id: number) {
    return `${environment.mainServiceUrl}internalportal/lineitems/${id}/taxes`;
  }

  static createInvoice(): string {
    return this.url;
  }

  static getInvoiceSummaries(): string {
    return `${environment.mainServiceUrl}odata/internalportal/invoicesummaries`;
  }

  static getInvoices(): string {
    return `${environment.mainServiceUrl}odata/internalportal/invoices`;
  }

  static getInvoice(id: number): string {
    return `${environment.mainServiceUrl}odata/internalportal/invoices/${id}`;
  }

  static deleteInvoice(invoiceId: number): string {
    return `${this.url}/${invoiceId}`;
  }

  static createInvoiceLineItem(invoiceId: number): string {
    return this.getLineItemUrl(invoiceId);
  }

  static deleteInvoiceLineItem(invoiceId: number, lineItemId: number): string {
    return `${this.getLineItemUrl(invoiceId)}/${lineItemId}`;
  }

  static createInvoiceLineItemTax(lineItemId: number): string {
    return this.getTaxUrl(lineItemId);
  }

  static deleteInvoiceLineItemTax(lineItemId: number, taxId: number): string {
    return `${this.getTaxUrl(lineItemId)}/${taxId}`;
  }
}

class Alerts {
  private static readonly url = `${environment.mainServiceUrl}internalportal/alerts`;
  private static readonly odataUrl = `${environment.mainServiceUrl}odata/internalportal/alerts`;

  static createAlert(): string {
    return this.url;
  }

  static getAlerts(): string {
    return this.odataUrl;
  }

  static getAlert(alertId: number): string {
    return `${this.odataUrl}/${alertId}`;
  }

  static updateAlert(alertId: number): string {
    return `${this.url}/${alertId}`;
  }

  static deleteAlert(alertId: number): string {
    return `${this.url}/${alertId}`;
  }
}

export class Endpoints {
  static InternalUserAuth = InternalUserAuth;
  static MemberAuth = MemberAuth;
  static InternalUsers = InternalUsers;
  static Facilities = Facilities;
  static Members = Members;
  static MembershipApplications = MembershipApplications;
  static MembershipReinstatements = MembershipReinstatements;
  static MembershipReapplicationApplications = MembershipReapplicationApplications;
  static Championships = Championships;
  static Events = Events;
  static Taxes = Taxes;
  static GlAccounts = GlAccounts;
  static Invoices = Invoices;
  static Alerts = Alerts;
}
